import React from "react";
import { IFormContext } from "./types";
import {
  defaultBlocksExpanded,
  defaultFormState,
  defaultVisibleBlocks,
} from "./const";

// Creating the context with default values and typing
export const FormContext = React.createContext<IFormContext>({
  formState: defaultFormState,
  visibleBlocks: defaultVisibleBlocks,
  blocksExpanded: defaultBlocksExpanded,
  currentlyActiveBlock: "premiseblock",
  requestDetailsLoaded: false,
  setFormState: () => {}, // Placeholder function
  setVisibleBlocks: () => {}, // Placeholder function
  setBlocksExpanded: () => {}, // Placeholder function
  setCurrentlyActiveBlock: () => {}, // Placeholder function
  displayingSnackbar: null,
  setDisplayingSnackbar: () => {}, // Placeholder function
  displayingAlertBanner: null,
  setDisplayingAlertBanner: () => {}, // Placeholder function
  messageScrollingBlockRefId: undefined,
  setMessageScrollingBlockRefId: () => {},
  setRequestDetailsLoaded: () => {},
  sidebarStatus: {},
  setSidebarStatus: () => {},
  onlineAccountHolderDetails: {},
  setOnlineAccountHolderDetails: () => {},
});
